export default __webpack_public_path__ + "static/media/t2Sala3.094d1f24.jpg";